import TableQuickSearchToolbar from './TableQuickSearchToolbar';

export default TableQuickSearchToolbar;
